import { Component } from "@angular/core";
import { PluginService } from "./core/services/plugin.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  title = "app";
  // ssoLogin: any = null;

  constructor(public pluginService: PluginService) {

  }
  ngOnInit() {
    // console.log("href", window.location.href);
    // let uri = window.location.search.substring(1);
    // let params = new URLSearchParams(uri);

    // this.ssoLogin = {
    //   tokenSesion: params.get("tokenSesion")
    // };

  }
}
